import { GridContainer, Icon, ICONS } from '@bob/library'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapFooter } from '@websrc/DataMappers/mapFooter'
import React, { useState } from 'react'

import * as SC from './FooterLink.style'

export type FooterLinkSectionProps = {
  links: ReturnType<typeof mapFooter>['links']
}

const FooterLinkItem = (item: FooterLinkSectionProps['links'][0]) => {
  const [mobileShow, setMobileShow] = useState(false)

  return (
    <SC.SideWrapper desktop={6}>
      <SC.LargeTitle>{item.large_title}</SC.LargeTitle>
      <SC.LargeMobileButton
        aria-expanded={mobileShow ? 'true' : 'false'}
        onClick={() => setMobileShow((s) => !s)}
      >
        <span>{item.large_title}</span>
        <Icon icon={mobileShow ? ICONS.ARROW_UP : ICONS.ARROW_DOWN} size={24} />
      </SC.LargeMobileButton>
      <SC.ContentWrapper mobileShow={mobileShow}>
        {item.link_sections.map((linkSection, sectionI) => (
          <SC.SectionWrapper aria-label={linkSection.section_title} key={sectionI}>
            <SC.LinkList>
              <SC.CategoryTitle>{linkSection.section_title}</SC.CategoryTitle>
              {linkSection.links.map((link, linkI) => (
                <SC.LinkListItem key={linkI}>
                  <SC.Link
                    href={link.href}
                    onClick={() =>
                      matomo.trackEvent(
                        'engagement',
                        'all',
                        [item.large_title],
                        [linkSection.section_title, link.title],
                        'text'
                      )
                    }
                  >
                    {link.title}
                  </SC.Link>
                </SC.LinkListItem>
              ))}
            </SC.LinkList>
          </SC.SectionWrapper>
        ))}
      </SC.ContentWrapper>
    </SC.SideWrapper>
  )
}

export const FooterLink = ({ links }: FooterLinkSectionProps) => {
  if (!links.length) return null

  return (
    <div className={'container-coral-spot'}>
      <SC.LinksWrapper>
        {links.map((link, key) => (
          <FooterLinkItem {...link} key={key} />
        ))}
      </SC.LinksWrapper>
    </div>
  )
}
